import { render, staticRenderFns } from "./incomeTaxProofFormPlan.vue?vue&type=template&id=18348284&scoped=true"
import script from "./incomeTaxProofFormPlan.vue?vue&type=script&lang=js"
export * from "./incomeTaxProofFormPlan.vue?vue&type=script&lang=js"
import style0 from "./incomeTaxProofFormPlan.vue?vue&type=style&index=0&id=18348284&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18348284",
  null
  
)

export default component.exports